import type { RootState } from '#app/store/root'
import { isComponentConfigurationAction } from '#store/componentConfiguration'
import { isLayoutConfigAction } from '#store/layoutConfiguration'
import { buildLocalStorageMiddleware, type ReduxVersion } from '#store/middleware/localStorage'

const storageTypeName = 'maic-admin-local-storage' as const

export const makeAppLocalStorage = () =>
  buildLocalStorageMiddleware<RootState, typeof storageTypeName>({
    db: 'maic-admin',
    key: 'root-store',
    version: 'v0.1.0' as ReduxVersion,
    type: storageTypeName,
    makeStoredState: (clonedState) => {
      const copy: Partial<RootState> = {}

      copy.layoutConfiguration = clonedState.layoutConfiguration
      copy.componentConfiguration = clonedState.componentConfiguration

      return copy
    },
    shouldSave: (action) => {
      return isLayoutConfigAction(action) || isComponentConfigurationAction(action)
    },
  })
